module.exports = __webpack_public_path__ + "img/26.73940993.png";